<template>
	<div class="c-brands">
		<PageHeader :byline="byline" :showMenu="true">
			<template v-slot:title>
				{{ tagline }}

				<!-- <span>
					You can track upto {{ workspace.trackerLimit }} brands on your current
					plan.
					<router-link to="/profile/billing">Upgrade your plan</router-link> to
					track more brands.</span
				> -->
			</template>
			<template v-slot:menu>
				<a class="btn btn-primary" @click="onAddBrand">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M12 12V8M12 12V16M12 12H16M12 12H8M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23Z"
							stroke="currentColor"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
						/>
					</svg>

					<span> Track brand </span>
				</a>
			</template>
		</PageHeader>
		<!-- <Track></Track> -->
		<router-view> </router-view>
		<List v-if="init" ref="list"></List>
	</div>
</template>

<script>
import PageHeader from '@swipekit/components/utils/page-header';
import List from './list';
import Track from './track';

export default {
	components: {
		PageHeader,
		List,
		Track,
	},

	data: function () {
		return {
			init: false,
		};
	},

	props: {
		standalone: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		byline: function () {
			return 'Brand Tracker';
		},
		tagline: function () {
			return `Track & analyze brands`;
		},
		fullCleanPath: function () {
			let path = this.$route.fullPath;

			path = path.split('?')[0];

			return path;
		},
		workspace: function () {
			return this.$store.getters['workspaces/all'];
		},
	},

	methods: {
		onEnd: function () {
			if (!this.$refs.list) {
			} else {
				this.$refs.list.onEnd();
			}
		},
		onAddBrand: function () {
			this.$store.dispatch('app/setAddBrand', true);
		},
	},

	mounted: function () {
		this.init = true;
	},
};
</script>

<style lang="scss">
.c-brands {
	position: relative;

	&:after {
		content: '';
		position: absolute;
		z-index: -1;
		top: 0;
		left: 0;
		width: 100%;
		height: 320px;
	}

	.c-page-header {
		&__inner {
			h1 > span {
				margin-top: var(--spacer-sm);
				font-size: var(--font-size);
				display: block;

				font-weight: 400;
			}
		}
	}
}
</style>
